import { render } from "./shield.svg.vue?vue&type=template&id=0368c764"
import script from "./shield.svg.vue?vue&type=script&lang=js"
export * from "./shield.svg.vue?vue&type=script&lang=js"
script.render = render

export default script